/* eslint-disable default-case */
import produce from 'immer';

import { types, SettingsState, SettingsActionTypes, SetConfigurationId, SetClientIntegrationId } from './types';

// Actions
export const actions = {
  setConfigurationId: (payload: string): SettingsActionTypes => ({ type: types.SET_CONFIGURATION_ID, payload }),
  setClientIntegrationId: (payload: string): SettingsActionTypes => ({ type: types.SET_CLIENT_INTEGRATION_ID, payload })
};

// Initial State
export const initialState: SettingsState = {
  configurationId: '',
  clientIntegrationId: ''
};

// Reducer
export const reducer = (state: SettingsState = initialState, action: SettingsActionTypes): SettingsState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case types.SET_CONFIGURATION_ID:
        draft.configurationId = (action as SetConfigurationId).payload;
        break;
      case types.SET_CLIENT_INTEGRATION_ID:
        draft.clientIntegrationId = (action as SetClientIntegrationId).payload;
        break;
    }
  });
};
